import React from "react";

const ImageUploadField = ({ name, index, item, setFieldValue, imageFile, accept = "image/*" }) => {
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      imageFile[index] = file;
      const reader = new FileReader();
      reader.onload = () => {
        setFieldValue(`${name}[${index}].image`, reader.result);
        setFieldValue(`${name}[${index}].fileName`, file.name);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageRemove = (name, index, setFieldValue) => {
    setFieldValue(
      `${name}[${index}].${
        item?.image
          ? "image"
          : item?.fileUrl
          ? "fileUrl"
          : item?.image_url
          ? "image_url"
          : "image"
      }`,
      ""
    );
    setFieldValue(`${name}[${index}].fileName`, "");
  };

  const isImageFile = (url) => {
    if (!url) return false;
    if (url.startsWith("data:")) {
      return url.startsWith("data:image/");
    }
    return /\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(url);
  };

  const fileUrl = item?.image || item?.fileUrl || item?.image_url;
  const isImg = isImageFile(fileUrl);

  return (
    <div className="mt-1">
      {fileUrl ? (
        <div
          style={{
            border: "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "4px",
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            background: "#fff",
            maxWidth: "100%"
          }}
        >
          {isImg ? (
            <img
              src={fileUrl}
              alt="preview"
              style={{
                height: "36px",
                width: "36px",
                objectFit: "cover",
                borderRadius: "4px"
              }}
            />
          ) : (
            <div
              style={{
                height: "36px",
                width: "36px",
                borderRadius: "4px",
                background: "#f0f4f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #d0d7de"
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#0056b3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
              </svg>
            </div>
          )}
          <span className="small text-muted ml-2 mr-4 text-truncate" style={{ maxWidth: '150px' }}>
            {item.fileName || item.version || (isImg ? 'Image Attached' : 'File Attached')}
          </span>
          <button
            type="button"
            style={{
              cursor: "pointer",
              color: "#dc3545",
              position: "absolute",
              right: 4,
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              fontSize: "14px",
              padding: "0 5px"
            }}
            onClick={() => handleImageRemove(name, index, setFieldValue)}
          >
            ✖
          </button>
        </div>
      ) : (
        <input
          type="file"
          {...(accept && accept !== "*" ? { accept } : {})}
          onChange={handleImageChange}
          className="form-control p-1"
        />
      )}
    </div>
  );
};

export default ImageUploadField;
